<template>
  <div class="employee-selector">
    <Autosuggest
      :model="localValue"
      :suggestions="filteredEmployees"
      @change="onInputChange"
      @select="onSelected"
      size="sm"
      :limit="10"
      :disabled="disabled"
      :placeholder="placeholder"
    >
      <template #custom="{suggestion}">
        <div>
          <span>{{ suggestion.item.suggestionName }}</span>
        </div>
      </template>
    </Autosuggest>
  </div>
</template>

<script>
import { defineComponent, ref, watch, onMounted } from 'vue';
import useEmployeeSearch from '../composables/useEmployeeSearch';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

export default defineComponent({
  name: 'EmployeeSelector',

  components: {
    Autosuggest,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    employeeId: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Tìm nhân viên...',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['input', 'select'],

  setup(props, { emit }) {
    const localValue = ref(props.value || '');

    const {
      employees,
      filteredEmployees,
      isLoading,
      loadEmployees,
      filterEmployees,
    } = useEmployeeSearch();

    watch(
      () => props.value,
      (newValue) => {
        localValue.value = newValue || '';
      },
    );

    const onInputChange = (text) => {
      localValue.value = text || '';
      filterEmployees(text);
      emit('input', text);
    };

    const onSelected = (option) => {
      const employee = option.item;
      localValue.value = employee.name;
      emit('input', employee.name);
      emit('select', employee);
    };

    const initializeSelectedEmployee = () => {
      if (!props.employeeId) return;

      loadEmployees().then(() => {
        const employee = employees.value.find(
          (emp) => emp.id === props.employeeId,
        );
        if (employee) {
          localValue.value = employee.name;
          emit('input', employee.name);
        }
      });
    };

    onMounted(() => {
      initializeSelectedEmployee();
    });

    return {
      localValue,
      filteredEmployees,
      isLoading,
      onInputChange,
      onSelected,
    };
  },
});
</script>

<style scoped></style>
